import {
    FetchState
} from "@/shared/types";
import { CardEmployerPrinState, EmployerPrinSettingsResponse, CardEmployerPrinSettingsRequest } from "@/admin/types";
import * as CardService from "@/shared/api/cardService";
import * as storeHelper from "@/shared/storeHelper";
import _ from "lodash";
import { defineStore } from "pinia";

export const initialState: CardEmployerPrinState = {
    fetchState: FetchState.Uninitialized,
    externalEmployerId: "",
    prin: ""
};

export const useCardEmployerPrinStore = defineStore("cardEmployerPrin", {
    state: (): CardEmployerPrinState => (_.cloneDeep(initialState)),
    getters: {
        isLoaded: state => state.fetchState === FetchState.Loaded,
        getPrin: state => state.prin,
        getExternalEmployerId: state => state.externalEmployerId
    },
    actions: {
        setFetchState (fetchState: FetchState) {
            this.fetchState = fetchState;
        },
        setEmployerPrin (response: EmployerPrinSettingsResponse ) {
            this.externalEmployerId = response.externalEmployerId;
            this.prin = response.prin;
            this.fetchState = FetchState.Loaded;
        },

        getEmployerPrinSettings (employerId: number) {
            return CardService.getEmployerPrinSettings(employerId)
                            .then(
                                response => this.setEmployerPrin(response.data))
                            .catch(error => storeHelper.handleError({ error, rethrow: true }))
                            .finally(() => this.setFetchState(FetchState.Loaded));
        },
        saveEmployerPrinSettings (request: CardEmployerPrinSettingsRequest) {
              return CardService.saveCardEmployerPrinSettings(request)
              .catch(error => {
                return storeHelper.handleError({error, rethrow: true});
              });
            }
    }
});
